"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchClient = void 0;
const instant_meilisearch_1 = require("@meilisearch/instant-meilisearch");
const lite_1 = __importDefault(require("algoliasearch/lite"));
function getSearchClient(settings) {
    return settings.searchBackend === 'algolia'
        ? (0, lite_1.default)(settings.appId, settings.apiKey)
        : (0, instant_meilisearch_1.instantMeiliSearch)(settings.host, settings.apiKey).searchClient;
}
exports.getSearchClient = getSearchClient;
//# sourceMappingURL=getSearchClient.js.map